import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";

interface Props {
  clientId: number
  payPerSepaAllowed: boolean;
  payPerInvoiceAllowed: boolean;
  paymentMethod: server.dto.ClientPaymentMethodTypes;
}
export const paymentMethodSection = (props: Props): FormSection => {
  const { clientId, payPerInvoiceAllowed, payPerSepaAllowed, paymentMethod } = props;

  return {
    key: "payments",
    type: "regular",
    title: "Payment method",
    fields: [
      {
        key: "payPerSepa",
        label: "Pay per SEPA",
        render: () => <YesNoText value={payPerSepaAllowed} />,
        inPageEdit: {
          render: ({ value, onChange }) => <YesNoRadioGroupForInPageEditing
            value={value}
            onChange={(v) => onChange(v, true)}
          />,
          fullWidth: false,
          type: "custom",
          initialValue: payPerSepaAllowed,
          submitChange: async (i) => window.CoreApi.Client.UpdatePaymentMethodSepaDebit({ clientId, allowed: i })
        }
      }, {
        key: "payPerInvoice",
        label: "Pay per invoice",
        render: () => <YesNoText value={payPerInvoiceAllowed} />,
        inPageEdit: {
          render: ({ value, onChange }) => <YesNoRadioGroupForInPageEditing
            value={value}
            onChange={(v) => onChange(v, true)}
          />,
          fullWidth: false,
          type: "custom",
          initialValue: payPerInvoiceAllowed,
          submitChange: async (i) => window.CoreApi.Client.UpdatePaymentMethodPerInvoice({ clientId, allowed: i })
        }
      }, {
        key: "paymentMethod",
        label: "Current method",
        render: () => <div>
          {paymentMethod}
        </div>
      }
    ]
  }
}